function _authHeader() {
  let user = JSON.parse(localStorage.getItem("_user"));
  if (user && user.attributes.token) {
    return { Authorization: "Bearer " + user.attributes.token };
  } else {
    return {};
  }
}

export {
  _authHeader,
}